import { Component, computed, inject, Inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ContentChange, QuillModule } from 'ngx-quill';
import DOMPurify from 'dompurify';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


export interface QuillEditorDialogData {
  elemId: string;
  currentValue: string;
  currentHtmlValue: string | null;
  tag: string;
}

@Component({
  selector: 'app-quill-editor-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    QuillModule
  ],
  templateUrl: './quill-editor-dialog.component.html',
  styleUrl: './quill-editor-dialog.component.scss'
})
export class QuillEditorDialogComponent implements OnInit {  
  private sanitizer = inject(DomSanitizer);

  htmlContent: string = '';
  textContent: string = '';

  private sanitizedHtml = signal<SafeHtml>('');
  public safePreview = computed(() => this.sanitizedHtml());

  quillConfig={
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        // [{ 'header': [1, 2, 3, 4, false] }],
        [{ 'color': [] }, { 'background': [] }],
        //[{ 'font': [] }],
        // [{ 'align': [] }],
        ['clean'],                                         // remove formatting button
        ['link'],
        //['link', 'image', 'video'] 
      ],
      
    },
    // clipboard: {
    //   matchVisual: false, // Kopierter Text übernimmt kein Styling
    // },
    history: {
      delay: 2000, // Zeit für "Undo"
      maxStack: 100, // Maximale Undo/Redo-Schritte
    },
  }

  editorStyle = {
  };

  constructor(
    public dialogRef: MatDialogRef<QuillEditorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: QuillEditorDialogData
  ) {}

  ngOnInit() {
    const initialHtml = this.data.currentHtmlValue || 
                       (this.data.currentValue ? `<${this.data.tag}>${this.data.currentValue}</${this.data.tag}>` : '');
    console.log('Tag', this.data.tag)
    console.log('INITIAL HTML', initialHtml)
    
    // Apply custom classes initially for proper display in editor
    const htmlWithClasses = this.addCustomClassToHTMLInitial(initialHtml);
    console.log('HTML WITH CLASSES', htmlWithClasses)
    this.htmlContent = htmlWithClasses;
    this.updatePreview(htmlWithClasses);
  }

  onContentChanged(event: ContentChange) {
      this.textContent = event.text ? event.text.trim() : '';
      this.updatePreview(event.html || '');
  }

  private updatePreview(rawHtml: string) {
    const clean = DOMPurify.sanitize(rawHtml);
    this.sanitizedHtml.set(this.sanitizer.bypassSecurityTrustHtml(clean));
  }

  isEditorEmpty(): boolean {
    return this.textContent.length === 0;
  }

  clearHtmlContent() {
    // Clear HTML content to use simple text mode
    this.dialogRef.close({ 
      htmlValue: null, 
      textValue: this.data.currentValue 
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  onSave() {
    const htmlWithClasses = this.addCustomClassToHTMLSave(this.htmlContent);
    console.log('html with custom classes', htmlWithClasses);
    const sanitizedHtml = this.sanitizeInput(htmlWithClasses);
    console.log('sanitized html', sanitizedHtml);
    this.dialogRef.close({ 
      htmlValue: sanitizedHtml,
      textValue: this.textContent
    });
  }

  private sanitizeInput(html: string): string {
    return DOMPurify.sanitize(html);
  }

  getSanitizedPreview(): string {
    return this.sanitizeInput(this.htmlContent);
  }

  // private stripHtml(html: string): string {
  //   const temp = document.createElement('div');
  //   temp.innerHTML = html;
  //   return temp.textContent || temp.innerText || '';
  // }

  private addCustomClassToHTMLInitial(html: string): string {
    console.log('Adding custom classes to HTML:', html);
    return html
        .replace(/&nbsp;/g, " ")        
        .replace(/<h1>/g, "<h1 class='custom-display-large'>") 
        .replace(/<h2>/g, "<h2 class='custom-headline-medium'>")
        .replace(/<h3>/g, "<h3 class='custom-title-medium'>")
        .replace(/<h4>/g, "<h4 class='custom-title-large'>")
        .replace(/<p>/g, "<p class='custom-body-medium'>")
        .replace(/p-large/g, "p-large class='custom-body-large'")
        .replace(/<span>/g, "<p class='span'>");
  }

  private addCustomClassToHTMLSave(html: string): string {
    console.log('Adding custom classes to HTML:', html);
    return html
        .replace(/&nbsp;/g, " ")        
        .replace(/<h1>/g, "<h1 class='custom-display-large'>") 
        .replace(/<h2>/g, "<h2 class='custom-headline-medium'>")
        .replace(/<h3>/g, "<h3 class='custom-title-medium'>")
        .replace(/<h4>/g, "<h4 class='custom-title-large'>")
        // .replace(/<p>/g, "<p class='custom-body-medium'>")
        // .replace(/p-large/g, "p-large class='custom-body-large'")
        .replace(/<p>/g, "<span>")
        .replace(/<\/p>/g, "</span>");
  }
}